// client/src/routes/app/properties/$propertyId/rent/index.tsx — SCR-PROP-003 tab „Chirii și
// încasări", its schedule view (D-2840, D-2841).
//
// SCR-RENT-001's board with the property pinned. The tab's link opens it on „Toate lunile"
// (`?all=true`) — the apartment's whole rent history, newest scadență first — and the month
// navigator is one pill away. `Leasing.Read`, as the board's own route.

import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { RequirePermission } from '@/components/layout/route-guards';
import { RentScheduleBoard } from '@/features/rent/RentScheduleBoard';
import { rentSearchSchema, type RentSearch } from '@/features/rent/search';

export const Route = createFileRoute('/app/properties/$propertyId/rent/')({
  validateSearch: rentSearchSchema,
  component: RentScheduleBoardTab,
});

function RentScheduleBoardTab() {
  const { propertyId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  return (
    <RequirePermission permission="Leasing.Read">
      <RentScheduleBoard
        pinnedPropertyId={propertyId}
        search={search}
        onSearchChange={(next: (previous: RentSearch) => RentSearch) => {
          void navigate({ search: next });
        }}
      />
    </RequirePermission>
  );
}
